import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";

export default function NoResult() {
  return (
    <div className="flex flex-col items-center justify-center gap-1 py-10">
      <FontAwesomeIcon
        icon={faMagnifyingGlass}
        className="text-lighter size-14 mb-4"
      />
      <p className="text-sm font-medium text-darker">No results found</p>
      <p className="text-sm text-light">Try searching different keywords</p>
    </div>
  );
}
